import { render, staticRenderFns } from "./Catagory.vue?vue&type=template&id=9b71436e&scoped=true"
import script from "./Catagory.vue?vue&type=script&lang=js"
export * from "./Catagory.vue?vue&type=script&lang=js"
import style0 from "./Catagory.vue?vue&type=style&index=0&id=9b71436e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b71436e",
  null
  
)

export default component.exports